export const RSC_HEADER = "RSC";
export const ACTION = "Next-Action";
export const NEXT_ROUTER_STATE_TREE = "Next-Router-State-Tree";
export const NEXT_ROUTER_PREFETCH_HEADER = "Next-Router-Prefetch";
export const NEXT_URL = "Next-Url";
export const RSC_CONTENT_TYPE_HEADER = "text/x-component";
export const FLIGHT_PARAMETERS = [
    [
        RSC_HEADER
    ],
    [
        NEXT_ROUTER_STATE_TREE
    ],
    [
        NEXT_ROUTER_PREFETCH_HEADER
    ]
];
export const NEXT_RSC_UNION_QUERY = "_rsc";
export const NEXT_DID_POSTPONE_HEADER = "x-nextjs-postponed";

//# sourceMappingURL=app-router-headers.js.map